import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import { createReferrer } from '../../../services/apiService';
import { getFullName } from '../../../utils';
import { RBACDialog } from './dialogBox';
import { MessageDialog } from './messageDialog';

function AddReferrer({ params, setEdit, edit, heading, onUpdateSelected }) {
  const [form, setForm] = React.useState({
    name: params?.data?.userDetail ? getFullName(params?.data?.userDetail) : '',
    email: params?.data?.userDetail ? params?.data?.userDetail.email : '',
    userGroup: params?.data?.userGroup ? params?.data?.userGroup : '',
    referralAmount: params?.data?.referralAmount
      ? params?.data?.referralAmount
      : '',
    utm_source: params?.data?.utmParams?.utm_source
      ? params?.data?.utmParams?.utm_source
      : '',
    utm_medium: params?.data?.utmParams?.utm_medium
      ? params?.data?.utmParams?.utm_medium
      : '',
    utm_campaign: params?.data?.utmParams?.utm_campaign
      ? params?.data?.utmParams?.utm_campaign
      : '',
    utm_term: params?.data?.utmParams?.utm_term
      ? params?.data?.utmParams?.utm_term
      : '',
    utm_content: params?.data?.utmParams?.utm_content
      ? params?.data?.utmParams?.utm_content
      : '',
  });
  const [openMessage, setOpenMessage] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [referralCode, setReferralCode] = React.useState('');
  const handleDialog = () => {
    setEdit((prev) => !prev);
  };
  const handleCreate = async () => {
    setLoading(true);
    try {
      const body = {
        name: form.name || getFullName(params?.data?.userDetail),
        email: form.email || params?.data?.userDetail?.email,
        userGroup: form.userGroup || params?.data?.userGroup,
        referralAmount: parseInt(form.referralAmount) * 100,
        utmParams: {
          utm_source: form.utm_source,
          utm_medium: form.utm_medium,
          utm_campaign: form.utm_campaign,
          utm_term: form.utm_term,
          utm_content: form.utm_content,
        },
      };
      const res = await createReferrer(body);
      setReferralCode(res?.referralCode || '');
      setOpenMessage(true);
      setEdit((prev) => !prev);
      onUpdateSelected();
    } catch (error) {
      console.log(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {openMessage && (
        <div>
          <MessageDialog
            handleDialog={() => setOpenMessage(false)}
            dialogOpen={openMessage}
            referralCode={referralCode}
            utm={form}
          />
        </div>
      )}
      {error && (
        <div>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={error}
            autoHideDuration={3000}
            onClose={() => {
              setError(false);
            }}
          >
            <Alert severity='error' sx={{ width: '100%' }}>
              Something went wrong. Please try again.
            </Alert>
          </Snackbar>
        </div>
      )}
      {edit && (
        <RBACDialog
          handleDialog={handleDialog}
          dialogOpen={edit}
          form={form}
          setForm={setForm}
          handleCreate={handleCreate}
          loading={loading}
          heading={heading}
          data={params?.data}
        />
      )}
    </>
  );
}

export default AddReferrer;
